import AbstractPeriodColumnTemplateSource from "./AbstractPeriodColumnTemplateSource.js";
import BudgetPeriodColumnSource from "../../../reports/columns/periodColumnSource/BudgetPeriodColumnSource.js";

/**
 * This class is used when a period column template should fetch data
 * from a budget. The term dynamic refers to the fact that this source will
 * use a budget from the current session, in particular, in the current company.
 * Therefore, the budget is unknown until the template interpretation.
 */
export default class DynamicBudgetPeriodColumnTemplateSource extends AbstractPeriodColumnTemplateSource {
	isBudgetSource() {
		return true;
	}

	_instanceClass() {
		return BudgetPeriodColumnSource;
	}

	_interpretationSpec({ context, columnTemplate, period }) {
		return {
			...super._interpretationSpec(...arguments),
			budgetId: this._getBudgetId({ context, columnTemplate, period }),
		};
	}

	_getBudgetId({ context, columnTemplate, period }) {
		const budgetIdSettings = context.getBudgetIdForTemplate(columnTemplate);

		if (budgetIdSettings) {
			return budgetIdSettings;
		}

		const year = period.getYear();
		const budget = year.getCurrentBudget() || year.getBudgets()[0];

		return budget?.getId();
	}
}
